import React, { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "../AuthContext";

// إنشاء السياق
const PermissionsContext = createContext();

// المزوّد (Provider)
export const PermissionsProvider = ({ children }) => {
  const { user, isAuthenticated } = useAuth(); // ناخد بيانات المستخدم بعد تسجيل الدخول
  const [permissions, setPermissions] = useState({});
  const [loading, setLoading] = useState(true);

 useEffect(() => {
  if (isAuthenticated && user?.permissions) {
    setPermissions(user.permissions);
    console.log("✅ Permissions Loaded:", user.permissions); // 👈 هنا
  } else {
    setPermissions({});
  }
  setLoading(false);
}, [isAuthenticated, user]);


  // دالة مساعدة للتحقق بسرعة
  const hasPermission = (key) => {
    // لو الصلاحية = 1 يبقى عنده إذن
    return permissions && permissions[key] === 1;
  };

  return (
    <PermissionsContext.Provider value={{ permissions, hasPermission, loading }}>
      {children}
    </PermissionsContext.Provider>
  );
};

// Hook مخصص للوصول السريع للسياق
export const usePermissions = () => useContext(PermissionsContext);
